import { List, ListItem, Typography, useMediaQuery } from "@mui/material";
import { metrics } from "@/utils/staticData/homeData";
import { getListStyles, listItemStyles } from "./styles";

const MetricList = () => {
  const isSmallMobile = useMediaQuery("(max-width: 374.98px)");

  return (
    <List disablePadding sx={getListStyles(isSmallMobile)}>
      {metrics.map((item, index) => (
        <ListItem key={index} disablePadding sx={listItemStyles}>
          <Typography
            variant="body1"
            fontSize={{ xs: isSmallMobile ? "0.75rem" : "0.85rem" }}
          >
            {item}
          </Typography>
        </ListItem>
      ))}
    </List>
  );
};

export default MetricList;
